import React, { ReactElement } from 'react';

interface IconProps {
  color?: string;
}

const PrivacyReportingAbuseIcon = ({ color = '#E21D4A' }: IconProps): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none">
      <mask
        id="a"
        width={26}
        height={26}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h26v26H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill={color}
          d="M13 18.565c.334 0 .615-.113.841-.34.226-.226.34-.506.34-.84 0-.333-.114-.614-.34-.844a1.135 1.135 0 0 0-.841-.343c-.334 0-.615.114-.841.343-.227.23-.34.51-.34.843 0 .334.113.613.34.84.226.227.507.341.841.341Zm-1.135-4.3h2.27V7.465h-2.27v6.798ZM8.847 22.97 3.03 17.154V8.846L8.845 3.03h8.308l5.817 5.816v8.308l-5.815 5.817H8.847Z"
        />
      </g>
    </svg>
  );
};

export default PrivacyReportingAbuseIcon;
